import {Component, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ItemsService} from "../../core/http/items.service";
import {Item} from "../../shared/models/item";
import {CategoryDto} from "../../shared/models/category-dto";
import {ItemDetailsPopupComponent} from "./item-details-popup/item-details-popup.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";
import {Category} from "../../shared/models/category";
import {PrinterCategoryQueueAssignmentDto} from "../../shared/models/printer-category-queue-assignment-dto";
import {PrinterService} from "../../core/http/printer.service";

@Component({
  selector: 'app-manage-items',
  templateUrl: './manage-items.component.html',
  styleUrls: ['./manage-items.component.scss']
})
export class ManageItemsComponent implements OnInit {
  items: Item[] = [];
  categories: Category[] = [];
  printCategories: PrinterCategoryQueueAssignmentDto[] = [];
  displayedColumns: string[] = ['itemNo', 'name', 'price', 'categoryIdentifier', 'printCategoryIdentifier', 'sortId', 'remainingQuantity', 'enabled', 'details', 'delete'];

  constructor(private itemsService: ItemsService, private printerService: PrinterService, private dialog: MatDialog,
              private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.itemsService.getAllCategoriesAndItems().subscribe({
      next: (response) => {
        const categoryDtos = response as CategoryDto[];

        this.items = categoryDtos.flatMap(dto =>
          dto.categoryItems.map(item => ({
            ...item,
            categoryName: dto.category.text
          }))
        );
      },
      error: (error) => {
        console.error(error);
      }
    });


    this.itemsService.getAllTenantCategories().subscribe({
      next: (response) => {
        this.categories = (<Category[]> response);
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.printerService.getQueuePrintAssignmentsForTenant().subscribe({
      next: (response) => {
        this.printCategories = (<PrinterCategoryQueueAssignmentDto[]> response);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  showItemDetails(item: Item): void {
    this.dialog.open(ItemDetailsPopupComponent, {
      data: {
        item: item,
        categories: this.categories,
        printCategories: this.printCategories,
        newItem: false
      }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        result.guid = item.guid;
        result.itemNo = item.itemNo;
        result.price = String(result.price).replace(',', '.');
        this.itemsService.updateItem(result).subscribe({
          next: (response) => {
            this._snackBar.open('Artikel geändert', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  createItem(): void {
    this.dialog.open(ItemDetailsPopupComponent, {
      data: {
        item: {},
        categories: this.categories,
        printCategories: this.printCategories,
        newItem: true
      }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      // console.log(result)
      if (result) {
        result.price = result.price.replace(',', '.');
        this.itemsService.createItem(result).subscribe({
          next: (response) => {
            this._snackBar.open('Artikel erstellt', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  deleteItem(item: Item): void {
    this.dialog.open(YesNoModalComponent, {
      data: item.name,
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.itemsService.deleteItem(item.guid).subscribe(result => {
          this._snackBar.open('Artikel ' + item.name + ' gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }

}
